import axios from 'axios'
import { baseApi, bluestoneH5Root } from '../config'
import '@/utils/cookieStore.js'
import { getUrlQuery } from '@/utils/common.js'
import router from '@/router'
import store from '@/store/index.js'
const service = axios.create({
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  config => {
    // loading状态
    const token = cookieStore.get('bs_session') || getUrlQuery('bs_session')
    // add token
    if (token) {
      Object.assign(config.headers, {
        'QUARTZ-SESSION': token
      })
    } else {
      // 如果没有session的情况直接跳去登录
      // location.href = getEnstatineHost() + '/createAccount/account/loginReg-phone.html?go=' + location.href
    }
    // 如果设置了请求格式，默认是application/json
    if (config.contentType) {
      Object.assign(config.headers, {
        'Content-Type': config.contentType
      })
    }
    // form-data格式
    if (config.contentType === 'application/x-www-form-urlencoded; charset=UTF-8') {
      config.transformRequest = [
        function(data) {
          // 在请求之前对data传参进行格式转换
          let ret = ''
          for (const it in data) {
            // 如果要发送中文 编码
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret.substring(0, ret.length - 1)
        }
      ]
    }
    // get 方法添加时间戳，防止被缓存
    if (config.method === 'get') {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      }
    }
    // 代理统一由steins处理， 请求地址修改 ,本地联调
    if (config.url.indexOf('mock') < 0 && config.url.indexOf('local') < 0) {
      config.url = baseApi + config.url
    }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
    // Toast.clear()
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    // Toast.clear()
    if (response.request.responseType === 'blob') {
      // 文件流直接返回
      return response.data
    }
    // 601 账号密码错误 602 会话号为空，603 登录状态过期
    if (response.data.errno === 602 || response.data.errno === 603) {
      // 直接清空cookie
      cookieStore.remove('bs_session')
      cookieStore.remove('nick_name')
      cookieStore.remove('region_code')
      cookieStore.remove('user_id')
      location.href = '/home'
    }
    // 特殊处理的接口，不需要公共拦截
    if (response.data.errno != 0 && !response.config.noIntercept) {
      // 如果请求失败
    }
    return response.data
  },
  error => {
    console.log(error)
    // Toast.clear()
    if (error && error.response) {
      switch (error.response.status) {
        case 404:
          router.push({ name: '404' })
          break
        case 500:
          router.push({ name: '500' })
          break
        default:
        // Toast(`连接出错(${error.response.status})!`)
      }
    } else {
      // Toast('网络错误')
    }
    // return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/index.js